// extracted by mini-css-extract-plugin
export var displayNone = "_tn-6";
export var imgContainer = "_tn-2";
export var overflowHidden = "_tn-3";
export var productInfoCardButtonContainer = "_tn-5";
export var productTitleText = "_tn-4";
export var rightArrow = "_tn-1";
export var rightArrowContainer = "_tn-0";